import platformBackendClient from '@backend-clients/platform-backend';

export default {
  send: (type, data) => new Promise((resolve, reject) => platformBackendClient
    .post(`/api/email/notification/${type}`, data)
    .then((res) => resolve(res))
    .catch((err) => reject(err))),
};
